import React from "react";
import "./historywrap.scss";

const historyWrap = ({ historyData }) => {
  
  return (
    <>
           <div className="content">
            
              {!!historyData.image?
               <img
                src={
                  historyData
                    ? historyData.image
                    : ""
                }
                alt="AboutImage"
                className="left-side"
              />
         :''}
           <h1>
                {historyData
                  ? historyData.history_title
                  : ""}
              </h1>

              <p
                dangerouslySetInnerHTML={{
                  __html: historyData
                    ? historyData.short_description
                    : "",
                }}
              >
                {}
              </p>
           
         
          </div>
       
    </>
  );
};

export default historyWrap;
